import {
    GET_SURVEY_PARTNERS,
    GET_RESTAURANT_SURVEY_PARTNER_SETTINGS, RESET_RESTAURANT_SURVEY_PARTNER_SETTINGS,
    SAVE_SURVEY_PARNER_SETTINGS
} from '../../../../actions/types';

const INITIAL_STATE = {
    surveyPartners: [],
    restaurantSurveyPartner: {}
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_SURVEY_PARTNERS:
            return {...state, surveyPartners: action.payload};
        case GET_RESTAURANT_SURVEY_PARTNER_SETTINGS:
            return {...state, restaurantSurveyPartner: action.payload};
        case SAVE_SURVEY_PARNER_SETTINGS:
            return state;
        case RESET_RESTAURANT_SURVEY_PARTNER_SETTINGS:
            return {...state,
                restaurantSurveyPartner: null
                };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/restaurants/settings/service/SurveyPartnerReducer.js